const MetricTimeUnit = Object.freeze({
  ALL: 'All',
  QUARTER: 'Quarter',
  MONTH: 'Month',
  WEEK: 'Week',
  DAY: 'Day',
  HOUR: 'Hour',
  HALF_HOUR: 'HalfHour',
  QUARTER_HOUR: 'QuarterHour',
  MINUTE: 'Minute'
})
export default MetricTimeUnit
export type MetricTimeUnitStrings = typeof MetricTimeUnit[keyof typeof MetricTimeUnit]
// RESERVE BELOW
